// ── Redirect de ?demo=1 / "Probar demo" al dominio de la demo separada ─────
// La demo vive en su propia infra (demo.condor360.app, back y DB propios).
// Whitelist explícita (no blacklist de demo.condor360.app): así, cualquier
// dominio no listado (demo.condor360.app, previews de Vercel, localhost)
// nunca redirige y sigue con el login/auto-login local, evitando un loop
// infinito si este mismo código corre en el dominio de la demo.
export const DEMO_HOST_REDIRECT_TARGET = 'https://demo.condor360.app/?demo=1';

const PROD_HOSTS_THAT_REDIRECT_TO_DEMO = ['condor360.app', 'www.condor360.app'];

export const shouldRedirectToDemoHost = (hostname) =>
  PROD_HOSTS_THAT_REDIRECT_TO_DEMO.includes(hostname);
